import { useState } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div<TSFixMe>`
  position: relative;
  display: flex;
  align-items: center;
`

const handleContentPosition = (props: TSFixMe): TSFixMe => {
  if (props.right) {
    return `
      left: calc(100% + 7px);
    `
  }

  return `
    right: calc(100% + 7px);
  `
}

const handleIndicatorPosition = (props: TSFixMe): TSFixMe => {
  if (props.noIndicator) {
    return `
      top: 100%;
    `
  }

  if (props.right) {
    return `
      left: -5px;
      top: calc(50% - 5px);
      rotate: 180deg
    `
  }

  return `
    right: -5px;
    top: calc(50% - 5px);
  `
}

const Content = styled.div<TSFixMe>`
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.09);
  background-color: #2a2d2f;
  border-radius: 5px;
  color: #ffffff;
  position: absolute;
  font-size: 13px;
  min-width: 125px;
  padding: 5px 10px;
  z-index: 10;
  ${handleContentPosition}

  &:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 5px solid #2a2d2f;
    clear: both;
    z-index: 10;

    ${handleIndicatorPosition}
  }
`

export const Tooltip = ({ toggle, children, ...props }: TSFixMe): TSFixMe => {
  const [open, setOpen] = useState(false)

  const handleMouseEnter = (): TSFixMe => {
    setOpen(true)
  }

  const handleMouseLeave = (): TSFixMe => {
    setOpen(false)
  }

  return (
    <Wrapper>
      <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        {toggle}
      </div>

      {open && (
        <Content open={open} {...props}>
          {children}
        </Content>
      )}
    </Wrapper>
  )
}
